import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { TVitrinsFiltersReducer, TFilterAlias } from '../types';

const initialState: TVitrinsFiltersReducer = [
  {
    label: 'Срок',
    alias: 'sub-creditObtainingMethod',
    webType: 'Select',
    fields: [
      {
        name: 'Наличными',
        value: 'cash',
      },
    ],
    selectedValue: null,
  },
  {
    label: 'Без поручителей',
    alias: 'sub-guarantorFilter',
    webType: 'Select',
    fields: [
      {
        name: 'Без поручителей',
        value: 'noGuarantor',
      },
    ],
    selectedValue: null,
  },
  {
    label: 'Без справок',
    alias: 'sub-solvencyProof',
    webType: 'Select',
    fields: [
      {
        name: 'Без справок',
        value: 'without-income-references',
      },
    ],
    selectedValue: null,
  },
  {
    label: 'С любой кредитной историей',
    alias: 'sub-demands',
    webType: 'Select',
    fields: [
      {
        name: 'С любой кредитной историей',
        value: 'positive-credit-history',
      },
    ],
    selectedValue: null,
  },
  {
    label: 'Сумма',
    alias: 'amount',
    webType: 'Input',
    fields: [],
    selectedValue: null,
  },
  {
    label: 'Срок',
    alias: 'period',
    webType: 'Input',
    fields: [],
    selectedValue: null,
  },
];

export const vitrinsFiltersSlice = createSlice({
  name: 'vitrinsFilters',
  initialState,
  reducers: {
    toggleFilter(state, { payload }: PayloadAction<{ alias: TFilterAlias; value: string | number }>) {
      const { alias, value } = payload;
      const filter = state.find((f) => f.alias === alias);

      if (!filter) {
        throw new Error('not found filter by alias');
      }

      if (filter.selectedValue === value) {
        filter.selectedValue = null;
        return;
      }

      filter.selectedValue = value;
    },
  },
});

export const { toggleFilter } = vitrinsFiltersSlice.actions;
